export default __webpack_public_path__ + "static/media/complementary--photo-enforced--g1.7f00dc63.png";